// extracted by mini-css-extract-plugin
export var lbContainerOuter = "z_t4";
export var lbContainerInner = "z_t5";
export var movingForwards = "z_t6";
export var movingForwardsOther = "z_t7";
export var movingBackwards = "z_t8";
export var movingBackwardsOther = "z_t9";
export var lbImage = "z_vb";
export var lbOtherImage = "z_vc";
export var prevButton = "z_vd";
export var nextButton = "z_vf";
export var closing = "z_vg";
export var appear = "z_vh";